<template>

        <div class="account-page-padding">
            <B2BOrderHistory v-if="is_dealer" :orders="props.orders" id="dealer_order_history"/>
            <D2COrderHistory v-else :orders="props.orders" id="user_order_history"/>  
        </div>
</template>
<script lang="ts" setup>
    import Account from "@/Shared/Account.vue";
    import B2BOrderHistory from "@/components/B2BOrderHistory.vue";
    import D2COrderHistory from "@/components/D2COrderHistory.vue";
    import type { PropType } from "vue";
    import { type OrderResource } from "@interfaces/Order";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { computed } from "vue";

    let props = defineProps({
        orders: {
            type: Object as PropType<OrderResource>,
            default: () => ({
                data: [],
                meta: {
                    current_page: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 0
                }
            })
        }
    });

    let store = useSettingsStore();
    let { is_dealer } = storeToRefs(store);
</script>
